<!--
 * @Description: 
 * @Author: Niklaus
 * @Date: 2024-04-23 10:04:57
 * @LastEditors: Niklaus
 * @LastEditTime: 2026-04-14 14:28:43
-->
<template>
  <basic-container>
    <el-tabs @tab-click="tabsHandleClick" v-model="tabKey">
      <el-tab-pane label="待办事项" name="01">
        <avue-crud ref="table" :data="tableData" :page.sync="page" :option="tableOption" :table-loading="tableLoading"
          :search.sync="params" @search-change="onLoad" @on-load="onLoad" @refresh-change="onLoad"
          @row-update="(row, index, done, loading) => saveTableForm(row, done, loading)">
          <template slot-scope="{ size, row }" slot="menu">
            <el-button icon="el-icon-edit" :size="size || 'small'" type="text"
              @click="handleProcess(row)">处理</el-button>
          </template>
        </avue-crud>
      </el-tab-pane>
      <el-tab-pane label="已完成事项" name="02">
        <el-form ref="form" label-width="100px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="任务名称">
                <el-input v-model="params2.taskName" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="initDoneList" :loading="loading">搜索</el-button>
            </el-col>
          </el-row>
        </el-form>
        <avue-crud ref="table2" :data="tableData2" :page.sync="page2" :search.sync="params2" :option="tableOption2"
          :table-loading="tableLoading2" @on-load="initDoneList()" @search-change="initDoneList()"
          @refresh-change="initDoneList()">
          <template slot-scope="{ size, row }" slot="menu">
            <el-button icon="el-icon-edit" :size="size || 'small'" type="text" @click="handleDetail(row)">查看</el-button>
          </template>
        </avue-crud>
      </el-tab-pane>
    </el-tabs>

    <!-- 查看任务详情 -->
    <el-dialog :visible.sync="showDetail" :close-on-click-modal="false" :destroy-on-close="true" :with-header="false"
      :top="'8vh'" :body-style="{ padding: '0px' }" width="70%">
      <div slot="title" class="header-title">
        <!-- <span class="fts-16">{{ title }}</span> -->
      </div>
      <component v-if="component" :is="component" :id="info.businessId" :isTodo="true"
        :processInstanceId="info.processInstanceId"></component>
    </el-dialog>
  </basic-container>
</template>
<script>
import { getTodoList, getDoneList, queryHistoryList } from "@/api/flow/flow.js"

export default {
  data() {
    return {
      tableLoading: false,
      tableLoading2: false,
      loading: false,
      tableData: [],
      tableData2: [],
      tabKey: "01",
      params: {},
      params2: { taskName: "" },

      page: {
        pageSizes: this.$store.state.common.pageSizes,
        pagerCount: this.$store.state.common.pagerCount,
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      tableOption: {
        height: "auto",
        labelPosition: "top",
        searchLabelPosition: "right",
        searchMenuSpan: 24,
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "待办名称",
            prop: "taskName",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
        ],
      },

      page2: {
        pageSizes: this.$store.state.common.pageSizes,
        pagerCount: this.$store.state.common.pagerCount,
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },

      tableOption2: {
        height: "auto",
        searchMenuSpan: 12,
        searchMenuPosition: "right",
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu: true,
        column: [
          {
            label: "任务名称",
            prop: "businessTitle",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
          {
            label: "审批时间",
            prop: "historyTaskEndTime",
          },
          {
            label: "审批结果",
            prop: "pass",
          },
        ],
      },

      showDetail: false,
      component: null,
      info: {},
    }
  },
  methods: {
    onLoad() {
      getTodoList({
        current: this.page.currentPage,
        size: this.page.pageSize,
      })
        .then((res) => {
          this.tableLoading = false
          if (res.data && res.data.code === 200) {
            this.tableData = res.data.data.records
            this.page.total = res.data.data.total
          } else {
            this.tableData = []
            this.page.total = 0
          }
        })
        .catch((e) => {
          this.tableLoading = false
        })
    },

    handleDetail(row) {
      let component = row.route
      this.info = row
      require([`@/views/${component}.vue`], (componentModule) => {
        console.log(componentModule)
        if (componentModule && componentModule.default) {
          this.component = componentModule.default
          this.showDetail = true
        }
      })
    },
    /**
     * 查询已完成的待办任务
     */
    initDoneList() {
      this.loading = false
      getDoneList({
        current: this.page2.currentPage,
        size: this.page2.pageSize,
        taskName: `%${this.params2.taskName}%`,
      })
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.tableData2 = res.data.data.records.map((item) => {
              let t = item.variables
              t.categoryName = item.categoryName
              t.pass = item.pass ? "通过" : "未通过"
              t.createTime = item.createTime
              t.taskId = item.taskId
              t.processInstanceId = item.historyProcessInstanceId
              t.historyTaskEndTime = item.historyTaskEndTime
              return t
            })
            this.page2.total = res.data.data.total
          } else {
            this.tableData2 = []
            this.page2.total = 0
          }
        })
        .catch(() => {
          this.tableLoading2 = false
        })
    },
    handleProcess(row) {
      this.$store.commit("SET_CURRENT_TODO_INFO", row)
      this.$router.push("/flow/todo/detail?id=" + row.taskId)
    },

    tabsHandleClick() { },
  },
}
</script>
